import { off as t, on as s } from "./highrise632.mjs";
const d = "@@mmoContext", i = {
  mounted(o, { value: e }) {
    o[d] = {
      handler: void 0
    }, typeof e == "function" && (o[d].handler = e, s("mousemoveoutside", o, e));
  },
  updated(o, { value: e }) {
    const n = o[d];
    typeof e == "function" ? n.handler ? n.handler !== e && (t("mousemoveoutside", o, n.handler), n.handler = e, s("mousemoveoutside", o, e)) : (o[d].handler = e, s("mousemoveoutside", o, e)) : n.handler && (t("mousemoveoutside", o, n.handler), n.handler = void 0);
  },
  unmounted(o) {
    const { handler: e } = o[d];
    e && t("mousemoveoutside", o, e), o[d].handler = void 0;
  }
};
export {
  i as default
};
